import $ from "jquery";

let init = () => {
    var arr = [];

    $('.js-simple-filtering').on('click', (e) => {
        e.preventDefault();

        var selected = false;
        const target = $(e.target);
        const li = target.closest('li');
        const category = li.data("category");

        console.log(category);

        if (!arr.includes(category)) {
            li.addClass('selected');
            arr.push(category);
            selected = true;
        } else {
            arr.splice(arr.indexOf(category), 1);
            li.removeClass('selected');
        }

        if (arr.length) {
            $('.js-simple-filtering--item').each((i, item) => {
                const categories = $(item).data('categories').split('|');
                if ($(arr).filter(categories).length) {
                    $(item).show();
                } else {
                    $(item).hide();
                }
            });
        } else {
            $('.js-simple-filtering--item').show();
        }

        console.log(arr);
    });
}

export let simpleFiltering = {
	init: init
}